import { FinancialInstitutionBranchesRequest, FinancialInstitutionBranchesResponse } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

type ReturnTuple = [
  FinancialInstitutionBranchesResponse | undefined,
  (params: FinancialInstitutionBranchesRequest) => Promise<FinancialInstitutionBranchesResponse>,
  () => void,
];

// Tuple-shaped like the legacy portal hook the pay dialogs were written
// against; the implementation is the Direct Pattern (no withApiHook).
export default function useFetchFinancialInstitutionBranches(_props: Record<string, never>): ReturnTuple {
  const api = useApi();
  const [response, setResponse] = useState<FinancialInstitutionBranchesResponse>();

  async function fetchFinancialInstitutionBranches(params: FinancialInstitutionBranchesRequest) {
    try {
      const res = await api.fetchFinancialInstitutionBranches(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setResponse(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return [response, fetchFinancialInstitutionBranches, () => setResponse(undefined)];
}
